import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NDDDialogService } from '@ndk/ng-dialog';
import { Culture } from '@ndk/ng-i18n';
import { NDDOffSidebarService } from '@ndk/ng-offsidebar';
import { NDDTranslationService } from '@ndk/ng-translation';
import { Subject } from 'rxjs';

import { ITranslatedLanguages } from '@shared/regional-settings/regional-settings.model';
import { RegionalSettingsService } from '@shared/regional-settings/regional-settings.service';

@Component({
    template: require('./user-menu-content.component.html'),
    selector: 'ndd-user-menu-content',
})
export class UserMenuContentComponent implements OnInit, OnDestroy {
    public initialCurrentLang: string;
    public languages: ITranslatedLanguages[];
    public selectLanguage: boolean = false;

    private ngUnsubscribe: Subject<void> = new Subject<void>();

    constructor(
        private offSidebarService: NDDOffSidebarService,
        private translationService: NDDTranslationService,
        private dialogService: NDDDialogService,
        private router: Router,
        private regionalSettings: RegionalSettingsService,
    ) { }

    public ngOnInit(): void {
        this.regionalSettings
            .getTranslatedLanguages()
            .subscribe((response: ITranslatedLanguages[]) => {
                this.languages = response;

                this.initialCurrentLang = this.languages
                    .find((value: any) => value.cultureName.toLowerCase() === this.translationService.currentLang.toString().toLowerCase())
                    .nativeName;
            });
    }

    public ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    public changeLanguage(): void {
        this.selectLanguage = true;
    }

    public goToMySettings(): void {
        this.router.navigate(['/settings/my-settings']);

        this.offSidebarService
            .closeOffSidebar('ndd-ng-offsidebar-user-menu');
    }

    public setLanguage(lang: string): void {
        const culture: Culture = <unknown>lang as Culture;
        if (this.translationService.currentLang === culture) {
            this.dialogService.alert({ message: '360LanguageSelectedNoHasChanged' });
            this.selectLanguage = false;
        } else {
            this.dialogService.confirm({ message: '360ConfirmLanguageChange' })
                .subscribe((response: boolean) => {
                    if (response) {
                        this.translationService.currentLang = culture;
                        this.selectLanguage = false;
                    }
                });
        }
    }
}
